import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { PaymentMethodCard } from "./PaymentMethodCard";
import { PaymentMethod } from "@/types/payment";

interface PaymentMethodsListProps {
  paymentMethods: PaymentMethod[];
  isLoading: boolean;
  onAddPayment: () => void;
  onDeletePayment: (id: string) => void;
}

export const PaymentMethodsList = ({
  paymentMethods,
  isLoading,
  onAddPayment,
  onDeletePayment,
}: PaymentMethodsListProps) => {
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">Payment Methods</h2>
        <Button onClick={onAddPayment} className="bg-primary text-white hover:bg-primary/90">
          <Plus className="h-4 w-4 mr-2" />
          Add Payment Method
        </Button>
      </div>

      {paymentMethods.length === 0 ? (
        <Card className="p-6 text-center text-gray-500">
          No payment methods added yet.
        </Card>
      ) : (
        <div className="space-y-4">
          {paymentMethods.map((method) => (
            <PaymentMethodCard
              key={method.id}
              id={method.id}
              paymentType={method.payment_type}
              lastFour={method.last_four}
              bankLastFour={method.bank_last_four}
              cardExpiry={method.card_expiry}
              cardCvv={method.card_cvv}
              cardNumber={method.card_number}
            />
          ))}
        </div>
      )}
    </div>
  );
};